import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import "./PerformanceModal.scss";

export default function PerformanceModal({ open, onClose }) {

  const roiData = [{ value: 15 }, { value: 85 }];
  const successData = [{ value: 65 }, { value: 35 }];

  const coinData = [
    { name: "Large Cap", value: 30, color: "#2ec7ff" },
    { name: "Mid Cap", value: 25, color: "#17c964" },
    { name: "Small Cap", value: 20, color: "#ffd166" },
    { name: "Bitcoin Cash", value: 15, color: "#a259ff" },
    { name: "Avalanche", value: 10, color: "#ff4d4f" }
  ];

  const tableData = [
    { coin: "Large Cap", success: "55.56%", roi: "55.56%" },
    { coin: "Mid Cap", success: "66.67%", roi: "66.67%" },
    { coin: "Small Cap", success: "61.54%", roi: "61.54%" },
    { coin: "Bitcoin Cash", success: "100%", roi: "55.56%" },
    { coin: "Avalanche", success: "100%", roi: "66.67%" },
    { coin: "Ethereum", success: "-", roi: "61.54%" },
    { coin: "Crypto Coin", success: "-", roi: "61.54%" }
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "750px",
          maxWidth: "90%",
          background: "#1c2137",
          borderRadius: "12px",
          color: "#fff",
          overflow: "hidden"
        }
      }}
    >

      <DialogContent className="perf-modal">

        {/* HEADER */}

        <div className="perf-header">
          <span>Last updated at – Jan 5, 2024, 06:53 PM IST</span>

          <div className="time-btns">
            <button>1M</button>
            <button>3M</button>
            <button>6M</button>
            <button>TV</button>
          </div>

          <span className="close" onClick={onClose}>✕</span>
        </div>

        {/* TOP SECTION */}

        <div className="perf-top">

          <div className="recommend-box">

            <div className="rec-title">
              Total Recommendation
              <span>100</span>
            </div>

            <div className="progress">
              <div className="green"></div>
              <div className="red"></div>
            </div>

            <div className="rec-stats">
              <span>78 Advances</span>
              <span>22 Declines</span>
            </div>

            <div className="rec-info">
              <div>Live Recommendation <b>4</b></div>
              <div>Latest Recommendation <b>20 Sep'23</b></div>
            </div>

          </div>

          {/* CIRCLES */}

          <div className="circle-charts">

            <div className="circle">

              <ResponsiveContainer width={120} height={120}>
                <PieChart>
                  <Pie data={roiData} innerRadius={40} outerRadius={55} dataKey="value">
                    <Cell fill="#2d8cff"/>
                    <Cell fill="#3a3f5a"/>
                  </Pie>
                </PieChart>
              </ResponsiveContainer>

              <div className="circle-text">
                <b>15%</b>
              </div>

            </div>

            <div className="circle">

              <ResponsiveContainer width={120} height={120}>
                <PieChart>
                  <Pie data={successData} innerRadius={40} outerRadius={55} dataKey="value">
                    <Cell fill="#3CFF00"/>
                    <Cell fill="#3a3f5a"/>
                  </Pie>
                </PieChart>
              </ResponsiveContainer>

              <div className="circle-text">
                <b>65%</b>
              </div>

            </div>

          </div>

        </div>

<hr></hr>
        {/* BOTTOM */}

        <div className="perf-bottom">

          <div className="donut-chart">

            <div className="coin-text">Coin</div>

            <ResponsiveContainer width={220} height={220}>
              <PieChart>
                <Pie
                  data={coinData}
                  innerRadius={60}
                  outerRadius={90}
                  dataKey="value"
                >
                  {coinData.map((entry, i) => (
                    <Cell key={i} fill={entry.color}/>
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>

            <div className="coin-center">Coins</div>

          </div>

          {/* TABLE */}

          <div className="coin-table">

            <div className="table-head">
              <span>Coin</span>
              <span>Success Rate</span>
              <span>ROI</span>
            </div>

            <div className="table-body">
              {tableData.map((row, i) => (
                <div className="table-row" key={i}>
                  <span>{row.coin}</span>
                  <span>{row.success}</span>
                  <span>{row.roi}</span>
                </div>
              ))}
            </div>

          </div>

        </div>

      </DialogContent>

    </Dialog>
  );
}